<template>
  <div class="notification">
    <base-material-alert
      v-for="notification in notifications"
      :key="notification.id"
      :type="notification.type"
      :dismissible="notification.dismissible"
    >
      {{ notification.message }}
    </base-material-alert>
  </div>
</template>

<script>
import { instance } from "./instance";

export default {
  name: "Notifications",
  data: () => ({
    notifications: [],
    options: {
      type: "success",
      dismissible: true,
      timeout: 5000
    }
  }),
  mounted() {
    instance.$on("open", this.open);
  },
  methods: {
    open(message, options) {
      this.options = Object.assign(this.options, options);

      let id = Math.random() * 100000;
      this.notifications.push({
        id,
        message,
        type: this.options.type,
        dismissible: this.options.dismissible
      });
      if (this.options.timeout) {
        setTimeout(() => {
          this.notifications = this.notifications.filter(
            notification => notification.id != id
          );
        }, this.options.timeout);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.notification {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 999;
}
</style>
